import AutoForm from '@components/AutoForm'
import Button from '@components/Button'
import Phone from '@components/fields/Phone'
import withMessage from '@packages/justo-parts/lib/decorators/withMessage'
import autobind from 'autobind-decorator'
import debounce from 'lodash/debounce'
import {TFunction, withTranslation} from 'next-i18next'
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react'
import {Field, WithValue} from 'simple-react-form'

import styles from './styles.module.css'

const translationPrefix = 'checkout.checkout.profile.user.phone'

export interface UserPhoneProps {
  showMessage: Function
  me: any
  close: Function
  t: TFunction
}
@withMessage
export class UserPhone extends React.Component<UserPhoneProps> {
  state = {
    loading: false,
  }

  form: any
  autosave: any
  debouncedSave: any

  constructor(props) {
    super(props)
    this.form = React.createRef()
    this.autosave = () => {
      this.setState({loading: true})
      this.debouncedSave()
    }
    this.debouncedSave = debounce(async () => {
      await this.form.current.submit()
      this.setState({loading: false})
    }, 1000)
  }

  @autobind
  renderButton({phone}) {
    const usesButton = false
    if (!usesButton) return
    if (this.props.me.phone === phone) return

    return (
      <div>
        <Button onClick={() => this.form.current.submit()} primary>
          {this.props.t(`${translationPrefix}.labelUpdatePhone`)}
        </Button>
        <div className={styles.shouldSave}>
          {this.props.t(`${translationPrefix}.labelSaveChangesBeforeOrdering`)}
        </div>
      </div>
    )
  }

  render() {
    const user = this.props.me
    if (!user) return null
    return (
      <div className={styles.container}>
        <AutoForm
          mutation="setUserPhone"
          ref={this.form}
          doc={{userId: user._id, phone: user.phone}}
          onChange={this.autosave}
          onSuccess={() => {
            this.props.showMessage(this.props.t(`${translationPrefix}.labelSavedPhone`))
            this.props.close()
          }}
        >
          <Field
            label={this.props.t(`${translationPrefix}.labelYourPhone`)}
            placeholder={this.props.t(`${translationPrefix}.labelReasonPhoneRequired`)}
            fieldName="phone"
            type={Phone}
          />
          <WithValue>{this.renderButton}</WithValue>
          {this.state.loading && (
            <div className="description">{this.props.t(`${translationPrefix}.labelSaving`)}</div>
          )}
        </AutoForm>
      </div>
    )
  }
}

export default withTranslation()(UserPhone)
